import type { IScope } from "angular";
import { finalize } from "rxjs/operators";

import type { IPartnerSlim, IResponseWithLoading, ITeamSlim } from "App/Modules/Models";
import type { IPartnersRepository, ITeamsRepository } from "App/Modules/Repositories";
import type { IFormContainerResolve } from "App/Modules/Services";
import { extendWithLoadingAndFail } from "App/Modules/Services/ObservableExtensions";

export default class AddTeamComponentController {
    public static $inject: string[] = ["$scope", "mmPartnersRepository", "mmTeamsRepository"];

    public partners: IResponseWithLoading<IPartnerSlim[]>;

    public selectedPartner: IPartnerSlim;

    public team: ITeamSlim;

    public addResponse: IResponseWithLoading<ITeamSlim>;

    public resolve: IFormContainerResolve<ITeamSlim, void>;

    constructor(
        private readonly $scope: IScope,
        private readonly partnersRepository: IPartnersRepository,
        private readonly teamsRepository: ITeamsRepository,
    ) {}

    public $onInit() {
        extendWithLoadingAndFail(this.partnersRepository.getPartners())
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (response: IResponseWithLoading<IPartnerSlim[]>) => {
                    this.partners = response;
                    if (!response.hasError && response.data) {
                        if (this.partners.data.length === 1) {
                            this.selectedPartner = this.partners.data[0];
                        }
                    }
                },
                (error) => {
                    this.partners = error;
                },
            );
    }

    public cancel() {
        if (this.resolve.options.onCancel) {
            this.resolve.options.onCancel();
        }
    }

    public addTeam() {
        this.team.partnerId = this.selectedPartner.id;

        extendWithLoadingAndFail(this.teamsRepository.addTeam(this.team))
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (response: IResponseWithLoading<ITeamSlim>) => {
                    this.addResponse = response;
                    if (!response.isLoading && response.data) {
                        this.resolve.options.onOk(response.data);
                    }
                },
                (error) => {
                    this.addResponse = error;
                },
            );
    }
}
